/**
 * "Plans" — Billing section (ADR-0074).
 * Reconciled from billing-tier-catalog.ts (dev/starter/growth/scale/enterprise +
 * Growth's 14-day trial) and ADR-0035 (annual discount, hybrid routes). Prices
 * are NOT restated here — they live on /pricing.
 */
import type { DocPageContent } from '../types';

export const BILLING_PLANS_PAGE: DocPageContent = {
  slug: 'billing/plans',
  titleKey: 'docs.billing.plans.title',
  descriptionKey: 'docs.billing.plans.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.billing.plans.lead' },

    { kind: 'heading', level: 2, id: 'tiers', textKey: 'docs.billing.plans.tiers.heading' },
    { kind: 'paragraph', textKey: 'docs.billing.plans.tiers.body' },
    {
      kind: 'definitions',
      items: [
        {
          termKey: 'docs.billing.plans.tier.starter.term',
          descKey: 'docs.billing.plans.tier.starter.desc',
        },
        {
          termKey: 'docs.billing.plans.tier.growth.term',
          descKey: 'docs.billing.plans.tier.growth.desc',
        },
        {
          termKey: 'docs.billing.plans.tier.scale.term',
          descKey: 'docs.billing.plans.tier.scale.desc',
        },
        {
          termKey: 'docs.billing.plans.tier.enterprise.term',
          descKey: 'docs.billing.plans.tier.enterprise.desc',
        },
      ],
    },
    {
      kind: 'callout',
      tone: 'tip',
      titleKey: 'docs.billing.plans.pricing.title',
      textKey: 'docs.billing.plans.pricing.body',
      links: {
        pricing: { target: { path: '/pricing' }, labelKey: 'docs.common.link.pricing' },
      },
    },

    { kind: 'heading', level: 2, id: 'trial', textKey: 'docs.billing.plans.trial.heading' },
    { kind: 'paragraph', textKey: 'docs.billing.plans.trial.body' },

    { kind: 'heading', level: 2, id: 'annual', textKey: 'docs.billing.plans.annual.heading' },
    {
      kind: 'paragraph',
      textKey: 'docs.billing.plans.annual.body',
      links: {
        pricing: { target: { path: '/pricing' }, labelKey: 'docs.common.link.pricing' },
      },
    },

    { kind: 'heading', level: 2, id: 'discounts', textKey: 'docs.billing.plans.discounts.heading' },
    { kind: 'paragraph', textKey: 'docs.billing.plans.discounts.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.billing.plans.discounts.item.nonprofit',
        'docs.billing.plans.discounts.item.education',
        'docs.billing.plans.discounts.item.oss',
      ],
    },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.billing.plans.discounts.note.title',
      textKey: 'docs.billing.plans.discounts.note.body',
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.billing.plans.next.usage.title',
          textKey: 'docs.billing.plans.next.usage.text',
          to: { docSlug: 'billing/usage' },
        },
        {
          titleKey: 'docs.billing.plans.next.subscription.title',
          textKey: 'docs.billing.plans.next.subscription.text',
          to: { docSlug: 'billing/subscription' },
        },
      ],
    },
  ],
};
